import {
  TableBody,
  TableCell,
  Table as TableCore,
  TableHead,
  TableHeader,
  TableRow,
  TableCaption,
  Text,
  css,
  styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import type {TechnicalDataMultiValue} from './mergeTechnicalDataWithSameKey';
import {RowHeader} from './RowHeader';

interface TableProps {
  tableTitle?: string;
  caption?: string;
  values: TechnicalDataMultiValue[];
  groupKey: string;
}

export const hideVisually = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const StyledTableWrapper = styled.div`
  & thead {
    ${hideVisually};
  }

  padding-top: ${(props) => props.theme.size.static200};
`;

export const Table = (props: TableProps): JSX.Element => {
  const {tableTitle, values} = props;
  return (
    <StyledTableWrapper>
      <TableCore fixedHeaderColumn solidHeaderColumn>
        <TableCaption>{tableTitle}</TableCaption>
        <TableHead>
          <TableRow>
            <TableHeader emphasized>
              <Text bold wordBreak>
                {tableTitle}
              </Text>
            </TableHeader>
          </TableRow>
        </TableHead>

        <TableBody>
          {values.map(({description, values}) => (
            <TableRow key={description.label}>
              <TableHeader emphasized>
                <RowHeader row={description} />
              </TableHeader>
              <TableCell>
                <Text>{values.join(', ')}</Text>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableCore>
    </StyledTableWrapper>
  );
};
